const encodeFilename = (filename) => encodeURIComponent(filename || '');

export const assetUrl = (filename) => (
  `${process.env.PUBLIC_URL || ''}/assets/${encodeFilename(filename)}`
);

export const eventPhotoUrl = (filename) => (
  `/api/image/${encodeFilename(filename)}`
);

export const downloadPhotoUrl = (filename) => (
  `/api/download/${encodeFilename(filename)}`
);
